import React from 'react';

const AddCursoButton = ({ openAddCursoModal }) => {
  return (
    <div className="col-12 col-xl-3 col-md-6 py-1">
      <button 
        type="button" 
        className="d-flex align-items-center justify-content-center btn btn-primary text-white w-100 fw-semibold"
        onClick={openAddCursoModal}
      >
        <i className="bi bi-plus fs-4"></i> Curso
      </button>
    </div>
  );
};

export default AddCursoButton; 